<template>
  <div>
    <b-row>
        <b-col md="8">
            <h5>
                {{$t("Orders")}}
            </h5>
        </b-col>
        <b-col md="4" align="end" class="text-right text-end">
            <span class="text-green- t-link" @click="$router.push('orders')">
                {{$t("All orders")}}
            </span>
        </b-col>
    </b-row>
    <br>
    <b-row>
        <b-col class="orders-table">
            <b-table responsive :items="items">

            </b-table>
        </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    methods:{
        dateParse(date_iso){
            let date = new Date(date_iso)
            let day_month = date.toLocaleDateString().substr(0,6)
            let year = date.getFullYear().toString().substr(-2)
            return `${day_month}${year}`
        }
    },
    data() {
      return {
        items: [
          {
            date: this.dateParse(new Date().toISOString()),
            client: "Lorem ipsum",
            model: "13",
            amount: "13",
            mode: "Lorem ipsum"
          },
          {
            date: this.dateParse(new Date().toISOString()),
            client: "Lorem ipsum",
            model: "13",
            amount: "13",
            mode: "Lorem ipsum"
          },
          {
            date: this.dateParse(new Date().toISOString()),
            client: "Lorem ipsum",
            model: "13",
            amount: "13",
            mode: "Lorem ipsum"
          },
          {
            date: this.dateParse(new Date().toISOString()),
            client: "Lorem ipsum",
            model: "13",
            amount: "13",
            mode: "Lorem ipsum"
          },
        ],
        fields:[
            {
                key: 'date',
                label: 'Date'
            },
            {
                key: 'client',
                label: 'Client'
            },
            {
                key: 'model',
                label: 'Model'
            },
            {
                key: 'amount',
                label: 'Amount'
            },
            {
                key: 'mode',
                label: 'Mode'
            },
        ]
      }
    }
  }
</script>

<style lang="scss">
  .orders-table{
    .b-table{ 
        thead{ 
            background: #FFFFFF30;
            color: #ffffff !important;
        }
        tbody{
            tr{
                background: #FFFFFF1A;
                color: #ffffff !important;
                margin-top:3px !important;
                td{
                    border-bottom: 0.1px solid #1B2635 !important; 
                }
            }
        }
    }
  }
</style>